export default __webpack_public_path__ + "static/media/Himanshu Kesarwani.e20be432.webp";